import { ColumnDef } from "@tanstack/react-table";
import { TableRenderUtils } from "../../components/Table/TableRenderUtils";
import { RightsIntersectionRecord } from "../../api/useRightsApi";
import React from "react";

export function rightsIntersectionsColumnsDefinitionShort(t: any): Array<ColumnDef<Array<any>, any>> {
  return [
    {
      id: "ID",
      header: "ID",
      size: 0,
      maxSize: 1,
      enableSorting: false,
      accessorFn: (value) => value,
      cell: (value) => {
        return TableRenderUtils.renderBaseContent(value.getValue()[0] ?? "—", {
          className: "text-sm"
        });
      }
    },
    {
      id: "Contractor",
      header: t("contractor"),
      size: 1000,
      enableSorting: false,
      accessorFn: (value) => value,
      cell: (value) => {
        return TableRenderUtils.renderBaseContent(value.getValue()[1] ?? "—", {
          className: "text-sm"
        });
      }
    }
  ];
}

export function rightsIntersectionsColumnsDefinition(
  t: any
): Array<ColumnDef<RightsIntersectionRecord, any>> {
  return [
    {
      id: "ReleaseID",
      header: `${t("rights_intersections.release_id")}`,
      size: 130,
      enableSorting: false,
      accessorFn: (value) => value.release_id,
      cell: (value) => {
        return TableRenderUtils.renderBaseContent(value.getValue() ?? "—", {
          className: "text-sm"
        });
      }
    },
    {
      id: "ExternalID",
      header: `${t("rights_intersections.external_id")}`,
      size: 130,
      enableSorting: false,
      accessorFn: (value) => value.external_id,
      cell: (value) => {
        return TableRenderUtils.renderBaseContent(value.getValue() ?? "—", {
          className: "text-sm"
        });
      }
    },
    {
      id: "Title",
      header: `${t("name")}`,
      size: 200,
      enableSorting: false,
      accessorFn: (value) => value.title,
      cell: (value) => {
        return TableRenderUtils.renderBaseContent(value.getValue() ?? "—", {
          className: "text-sm"
        });
      }
    },
    {
      id: "Artist",
      header: `${t("artist")}`,
      size: 200,
      enableSorting: false,
      accessorFn: (value) => value.display_artist_name,
      cell: (value) => {
        return TableRenderUtils.renderBaseContent(value.getValue() ?? "—", {
          className: "text-sm"
        });
      }
    },
    {
      id: "Contractor",
      header: `${t("contractor")}`,
      size: 200,
      enableSorting: false,
      accessorFn: (value) => value.contractor_title,
      cell: (value) => {
        return TableRenderUtils.renderBaseContent(value.getValue() ?? "—", {
          className: "text-sm"
        });
      }
    },
    {
      id: "Share",
      header: () => <div className={"w-100 text-right"}>{t("share")}</div>,
      size: 200,
      enableSorting: false,
      accessorFn: (value) => value.share,
      cell: (value) => {
        return TableRenderUtils.renderBaseContent(value.getValue() ? value.getValue() + "%" : "—", {
          className: "text-sm text-right"
        });
      }
    },
    {
      id: "IssueDate",
      header: `${t("rights_intersections.issue_date")}`,
      size: 200,
      enableSorting: false,
      accessorFn: (value) => value.issue_date,
      cell: (value) => {
        return TableRenderUtils.renderBaseContent(value.getValue() ?? "—", {
          className: "text-sm"
        });
      }
    },
    {
      id: "ExpireDate",
      header: `${t("rights_intersections.expire_date")}`,
      size: 200,
      enableSorting: false,
      accessorFn: (value) => value.expire_date,
      cell: (value) => {
        return TableRenderUtils.renderBaseContent(value.getValue() ?? "—", {
          className: "text-sm"
        });
      }
    }
  ];
}
